module.exports = __webpack_public_path__ + "media/images/application/template/icon--link-internal-d5fff6a6f789ab64bcb554d37f9eac69.svg";